import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { MKT } from '../../Marketing/links';
export default function KeiTrucks() {
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("p", {
                children: "Kei trucks are small, cheap to buy at auction and in steady demand from farms, ranches, resorts and hobbyists. They are also the JDM import with the most ways to go wrong after you win the bid. Before you import a kei truck from Japan, check these five things."
            }),
            /*#__PURE__*/ _jsx("h2", {
                children: "1. The 25-year rule still applies"
            }),
            /*#__PURE__*/ _jsxs("p", {
                children: [
                    "A kei truck is a motor vehicle like any other: it needs to be at least 25 years old, to the month of manufacture, to come in without meeting US safety standards. In 2026 that means trucks built in 2001 and earlier, each from its anniversary month. See",
                    ' ',
                    /*#__PURE__*/ _jsx("a", {
                        href: "/blog/25-year-rule-jdm-cars-eligible-2026",
                        children: "the 25-year rule"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ _jsx("h2", {
                children: "2. Your customer’s state decides where it can drive"
            }),
            /*#__PURE__*/ _jsx("p", {
                children: "Federal import is only half of it. Each state decides whether a kei truck can be titled and registered for public roads, and on which roads. Some title them like any truck, some limit them to low-speed roads or farm use, and some have tightened their rules in recent years. Check with the state’s DMV before you buy for a customer, and put what you found in writing."
            }),
            /*#__PURE__*/ _jsx("h2", {
                children: "3. How customs classifies it changes the duty"
            }),
            /*#__PURE__*/ _jsx("p", {
                children: "Customs generally treats a kei truck as a truck, not a passenger car, and trucks have long carried a much higher duty rate than cars: 25% (the “chicken tax”) against 2.5%. Tariffs on Japanese vehicles have changed several times since 2025, so ask your broker how they will classify the vehicle and what rate applies before you bid. Vans like the Every or Hijet van may be classified differently from the pickups."
            }),
            /*#__PURE__*/ _jsx("h2", {
                children: "4. The options US buyers ask for"
            }),
            /*#__PURE__*/ _jsxs("ul", {
                children: [
                    /*#__PURE__*/ _jsxs("li", {
                        children: [
                            /*#__PURE__*/ _jsx("strong", {
                                children: "4WD"
                            }),
                            " with a high/low transfer case, and a ",
                            /*#__PURE__*/ _jsx("strong", {
                                children: "diff lock"
                            }),
                            " on many trucks."
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("li", {
                        children: [
                            /*#__PURE__*/ _jsx("strong", {
                                children: "Air conditioning"
                            }),
                            " and ",
                            /*#__PURE__*/ _jsx("strong", {
                                children: "power steering"
                            }),
                            ": many work trucks were sold without them. Look for AC and PS on the sheet."
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("li", {
                        children: [
                            "A ",
                            /*#__PURE__*/ _jsx("strong", {
                                children: "dump bed"
                            }),
                            " (ダンプ) or a ",
                            /*#__PURE__*/ _jsx("strong", {
                                children: "jumbo cab"
                            }),
                            " with extra seat travel."
                        ]
                    }),
                    /*#__PURE__*/ _jsx("li", {
                        children: "Manual or automatic: manuals are common and suit off-road work."
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("h2", {
                children: "5. Rust underneath"
            }),
            /*#__PURE__*/ _jsxs("p", {
                children: [
                    "Kei trucks worked hard, often in snowy regions where roads are salted. The overall grade won’t always show it; the inspector’s notes will. Look for underbody rust (下廻り錆) and any S or C marks on the damage map, especially on the frame and bed. Ask your agent for photos underneath before bidding on anything with a note. How to find them:",
                    ' ',
                    /*#__PURE__*/ _jsx("a", {
                        href: "/blog/how-to-read-a-japanese-auction-sheet",
                        children: "how to read a Japanese auction sheet"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ _jsx("h2", {
                children: "Pricing it"
            }),
            /*#__PURE__*/ _jsxs("p", {
                children: [
                    "Kei truck hammer prices are low, so freight, duty and fees are a big share of the landed cost, and the duty rate matters more than on a car. Run the numbers with our",
                    ' ',
                    /*#__PURE__*/ _jsx("a", {
                        href: "/blog/jdm-import-cost-calculator",
                        children: "import cost calculator"
                    }),
                    " before you bid. Right Hand DMS can run a standing hunt for the configuration a customer wants (4WD, AC, dump bed, a grade floor) and price each match: see ",
                    /*#__PURE__*/ _jsx("a", {
                        href: MKT.product('hunts'),
                        children: "hunts"
                    }),
                    "."
                ]
            })
        ]
    });
}
